function isTouchScreenDevice() {
  return Boolean('ontouchstart' in window || navigator.maxTouchPoints);
}

export default isTouchScreenDevice();
